// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AllocationController from "./allocation_controller"
application.register("allocation", AllocationController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ColumnsController from "./columns_controller"
application.register("columns", ColumnsController)

import DueDateController from "./due_date_controller"
application.register("due-date", DueDateController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import LineItemsController from "./line_items_controller"
application.register("line-items", LineItemsController)

import NumberingController from "./numbering_controller"
application.register("numbering", NumberingController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import RecurringFormController from "./recurring_form_controller"
application.register("recurring-form", RecurringFormController)

import TemplatePreviewController from "./template_preview_controller"
application.register("template-preview", TemplatePreviewController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import ItemKindController from "./item_kind_controller"
application.register("item-kind", ItemKindController)

import ItemPickController from "./item_pick_controller"
application.register("item-pick", ItemPickController)
